import React, {Component} from 'react';
import './css/HelpPlanningQuestion.styl';
import {setCookie} from '../../../../../shared/utilities/cookies';
import {getGATags} from '../../../../../shared/utilities/GAHelpers';

export default class extends Component {
  static propTypes = {
    onAnswer: React.PropTypes.func,
  };

  setImmediate = () => {
    setCookie(
      '_leg_LG',
      encodeURIComponent(
        JSON.stringify([
          {
            name: 'q_preneed',
            a: 'Immediate help',
          },
        ])
      ),
      4 / 24
    );
    getGATags({
      eventCategory: 'fhd_planning',
      eventAction: 'fhd_need_click',
      eventLabel: 'fhd_need',
    });
    this.props.onAnswer('immediate');
  };

  setFuture = () => {
    setCookie(
      '_leg_LG',
      encodeURIComponent(
        JSON.stringify([
          {
            name: 'q_preneed',
            a: 'Future pre-planning',
          },
        ])
      ),
      4 / 24
    );
    getGATags({
      eventCategory: 'fhd_planning',
      eventAction: 'fhd_planning_click',
      eventLabel: 'fhd_planning',
    });
    this.props.onAnswer('future');
  };

  render() {
    return (
      <div className="help-planning-question">
        <header>How Can We Help?</header>
        <label>
          <input
            type="radio"
            data-id="immediate"
            name="planTiming"
            value="immediate"
            onClick={this.setImmediate}
          />
          <span>I have an immediate need</span>
        </label>
        <label>
          <input
            type="radio"
            data-id="future"
            name="planTiming"
            value="future"
            onClick={this.setFuture}
          />
          <span>I am planning for the future</span>
        </label>
        <p>
          Pre-planning means making arrangements for a funeral someday in the
          future.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/pages/Profile/components/Shared/HelpPlanningQuestion/index.js